<template>
    <div id="resourceForm" class="con-exemple-prompt">
        <vs-row>
            <vs-col vs-w="12">
                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Nom* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.name"
                            type="text"
                            name="name"
                            class="w-full"
                            required
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Délai de contribution* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.contribution_delay"
                            name="contribution_delay"
                            class="w-full"
                            required
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Délai de publication* :</span>
                    </div>
                    <div class="vx-col sm:w-2/3 w-full">
                        <vs-input
                            v-model="resource.publication_delay"
                            name="publication_delay"
                            class="w-full"
                            required
                        />
                    </div>
                </div>

                <div class="vx-row mb-6">
                    <div class="vx-col sm:w-1/3 w-full">
                        <span>Données anonymes* :</span>
                    </div>

                    <div class="vx-col sm:w-2/3 w-full">
                        <span class="mr-5">
                            <vs-radio v-model="resource.anonymous" vs-name="anonymous" :vs-value="true">Oui</vs-radio>
                        </span>
                        <span class="mr-5">
                            <vs-radio v-model="resource.anonymous" vs-name="anonymous" :vs-value="false">Non</vs-radio>
                        </span>
                    </div>
                </div>
            </vs-col>
        </vs-row>
    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'CampaignTypeForm',
    components: {
        Multiselect
    },
    props: {
        value: {
            required: false,
            type: Object
        }
    },
    data () {
        return {
            log: console.log,
            resource: {},
        }
    },
    watch: {
        'resource': {
            handler () {
                this.$emit('input', this.resource)
            }, deep: true
        },
        hasError (value) {
            this.$emit('error', value)
        }
    },
    computed: {
        hasError() {
            let error = !this.resource.name || !this.resource.contribution_delay || !this.resource.publication_delay
            return error;
        },
    },
    methods: {
        initResource() {
            this.resource = window._.cloneDeep(this.value);
        },
    },
    created() {
        this.initResource();
    }
}
</script>

<style lang="scss" scoped>

</style>
